<template>
  <v-container>
    <v-breadcrumbs
      v-if="isSala"
      :items="breadCrumbs"
      divider=">"
    ></v-breadcrumbs>

    <h2 class="mb-5">Cliente Oculto {{ municipio.nome }}/{{ municipio.uf }}</h2>
    <h3 class="mb-5" v-if="googleMeuNegocio && googleMeuNegocio.resposta">
      Nome no Google Meu Negócio: {{ googleMeuNegocio.resposta }}
    </h3>

    <div v-if="isEnviada()" class="enviada">
      <v-icon color="#fff">mdi-alert-circle</v-icon> Já foi finalizado
    </div>
    <v-form ref="form">
      <div v-for="(grupo, i) in perguntas" :key="i" class="grupo">
        <div
          v-if="habilitar(grupo.grupoId)"
          :class="` bloco`"
          :style="{ backgroundColor: groupColours[grupo.grupoId] }"
          @click="
            () => {
              onClickOpenGroup(grupo.grupoId);
              $forceUpdate();
            }
          "
        >
          {{ grupo.name }}

          <div v-if="openedGroup != grupo" style="margin-left: auto">
            <v-icon color="#fff">mdi-arrow-down-drop-circle-outline </v-icon>
          </div>
          <div v-if="openedGroup == grupo" style="margin-left: auto">
            <v-icon color="#fff">mdi-arrow-up-drop-circle-outline </v-icon>
          </div>
        </div>
        <div
          :style="{
            display: openedGroup == grupo.grupoId ? 'block' : 'none',
          }"
        >
          <div
            v-for="(children, index) in grupo.children"
            :key="index"
            style="position: relative"
            :style="{ backgroundColor: questionColours[grupo.grupoId] }"
          >
            <div
              :style="
                payload[children.grupoId][children.numero].status == 'loading'
                  ? 'opacity: 0.5'
                  : ''
              "
              class="children"
              v-if="!children.dependente || mostrarDependente(children)"
            >
              <div
                v-html="children.preambulo"
                class="subtitulo mb-4"
                v-if="children.preambulo"
              ></div>
              {{ children.texto }}
              <app-modal-show-evidence
                :evidence="children.evidencia"
                :color="'primary'"
                v-if="children.evidencia"
                :title="'Clique para saber mais'"
                :isHtml="true"
                :titulo="'Informação Importante'"
              >
              </app-modal-show-evidence>

              <div
                v-html="children.subtitulo"
                class="subtitulo mt-2"
                v-if="children.subtitulo"
              ></div>

              <template>
                <div
                  v-if="
                    children.perguntaId == 55 &&
                    instagram55 &&
                    instagram55.resposta
                  "
                  class="subtitulo mt-2"
                >
                  Instagram:
                  <a :href="instagram55.resposta" target="_blank">{{
                    instagram55.resposta
                  }}</a>
                </div>

                <div
                  v-if="children.perguntaId == 55 && facebook55"
                  class="subtitulo mt-2"
                >
                  Facebook:
                  <a :href="facebook55.resposta" target="_blank">{{
                    facebook55.resposta
                  }}</a>
                </div>

                <div
                  v-if="children.perguntaId == 55 && sieBlog55"
                  class="subtitulo mt-2"
                >
                  Site ou blog:
                  <a :href="sieBlog55.resposta" target="_blank">{{
                    sieBlog55.resposta
                  }}</a>
                </div>

                <div
                  v-if="
                    children.perguntaId == 58 &&
                    realizaEmail58 &&
                    realizaEmail58 == 'Não'
                  "
                  class="subtitulo mt-2"
                >
                  {{ realizaEmail58 }} realiza atendimento por email
                </div>

                <div
                  v-if="
                    children.perguntaId == 58 &&
                    email58 &&
                    realizaEmail58 == 'Sim'
                  "
                  class="subtitulo mt-2"
                >
                  Email de atendimento: {{ email58 }}
                </div>

                <div
                  v-if="
                    children.perguntaId == 58 &&
                    realizaWhatsapp58 &&
                    realizaWhatsapp58 == 'Não'
                  "
                  class="subtitulo mt-2"
                >
                  {{ realizaWhatsapp58 }} realiza atendimento por whatsapp
                </div>

                <div
                  v-if="
                    children.perguntaId == 58 &&
                    whatsapp58 &&
                    realizaWhatsapp58 == 'Sim'
                  "
                  class="subtitulo mt-2"
                >
                  Whatsapp de atendimento: {{ whatsapp58.resposta }}
                </div>

                <div
                  class="subtitulo mt-2"
                  v-if="
                    children.perguntaId == 48 &&
                    evidenciasDiagnosticoSelo.length > 0
                  "
                >
                  <div>Imagens do diagnóstico</div>

                  <div class="imagensDiagnostico">
                    <div
                      class="arquivo"
                      style="cursor: pointer"
                      v-for="(file, index) in evidenciasDiagnosticoSelo"
                      :key="index"
                      @click="
                        downloadEvidenciaDiagnostico(file.evidenciaId, file.url)
                      "
                    >
                      {{ file.nomeArquivo }}
                    </div>
                  </div>
                </div>
              </template>

              <div :class="`filho grupoId_${children.grupoId}`">
                <v-text-field
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-mask="['##:##-##:##']"
                  v-if="children.tipoResposta == tipoDiagnostico.intervalo"
                  placeholder="00:00-00:00"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? [rulesMaxIntervalo, rulesObg]
                      : [rulesMaxIntervalo]
                  "
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  hide-details="auto"
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-text-field>
                <v-text-field
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-if="children.tipoResposta == tipoDiagnostico.telefone"
                  :placeholder="'(00) 0000-0000'"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? [rulesObg]
                      : [true]
                  "
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  hide-details="auto"
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-text-field>
                <v-text-field
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-mask="['#####-###']"
                  v-if="children.tipoResposta == tipoDiagnostico.cep"
                  :placeholder="'00000-000'"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? [rulesMaxCep, rulesObg]
                      : [true]
                  "
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  hide-details="auto"
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-text-field>
                <v-textarea
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-if="children.tipoResposta == tipoDiagnostico.textArea"
                  placeholder="Escreva aqui"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? rules
                      : [true]
                  "
                  hide-details="auto"
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-textarea>
                <v-text-field
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-if="children.tipoResposta == tipoDiagnostico.numero"
                  placeholder="Escreva aqui"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? rules
                      : [true]
                  "
                  type="number"
                  hide-details="auto"
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-text-field>
                <v-text-field
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-if="children.tipoResposta == tipoDiagnostico.texto"
                  placeholder="Escreva aqui"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? rules
                      : [true]
                  "
                  hide-details="auto"
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-text-field>
                <v-text-field
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-if="children.tipoResposta == tipoDiagnostico.email"
                  placeholder="Escreva aqui"
                  :rules="emailRules"
                  hide-details="auto"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-text-field>
                <v-radio-group
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-if="children.tipoResposta == tipoDiagnostico.boolean"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero],
                      payload[children.grupoId][children.numero].desabilitado
                    )
                      ? rules
                      : [true]
                  "
                  hide-details="auto"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :disabled="
                    payload[children.grupoId][children.numero].status ==
                      'loading' ||
                    isEnviada() ||
                    payload[children.grupoId][children.numero].desabilitado
                  "
                  @change="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                >
                  <v-radio label="Sim" :key="1" :value="true"></v-radio>
                  <v-radio label="Não" :key="2" :value="false"></v-radio>
                </v-radio-group>
                <v-text-field
                  v-model="payload[children.grupoId][children.numero].resposta"
                  v-mascara="'##:##'"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? [rulesHoras, rulesObg]
                      : [rulesHoras]
                  "
                  v-if="children.tipoResposta == tipoDiagnostico.horaMin"
                  hide-details="auto"
                  placeholder="hh:mm"
                  :name="`resposta${children.grupoId}${children.numero}`"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :disabled="isEnviada()"
                  :readOnly="
                    payload[children.grupoId][children.numero].status ==
                    'loading'
                  "
                  @blur="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                ></v-text-field>
                <v-autocomplete
                  v-if="children.tipoResposta == tipoDiagnostico.lista115"
                  v-model="payload[children.grupoId][children.numero].resposta"
                  :ref="`resposta${children.grupoId}${children.numero}`"
                  :items="[
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                    '10',
                    '11',
                    '12',
                    '13',
                    '14',
                    '15',
                  ]"
                  placeholder="Selecione a quantidade"
                  :rules="
                    isRulesNeeded(
                      children,
                      payload[children.grupoId][children.numero]
                    )
                      ? rules
                      : [true]
                  "
                  @change="
                    () => {
                      save(
                        children,
                        grupo,
                        `resposta${children.grupoId}${children.numero}`,
                        i
                      );
                    }
                  "
                  :disabled="
                    payload[children.grupoId][children.numero].status ==
                      'loading' || isEnviada()
                  "
                  :clearable="true"
                >
                  <template slot="no-data"> Nenhum Ator retornado </template>
                </v-autocomplete>
                <div
                  style="width: 100%"
                  v-if="
                    children.tipoResposta == tipoDiagnostico.arquivo ||
                    children.tipoResposta == tipoDiagnostico.video ||
                    children.tipoResposta == tipoDiagnostico.audio
                  "
                >
                  <v-file-input
                    :rules="[
                      children.obrigatorio &&
                      !payload[children.grupoId][children.numero].files
                        ? rulesObg
                        : children.obrigatorio &&
                          payload[children.grupoId][children.numero].files &&
                          payload[children.grupoId][children.numero].files
                            .length > children.quantidadePermitida
                        ? `Essa pergunta só aceita até ${children.quantidadePermitida}`
                        : true,
                    ]"
                    :name="`resposta${children.grupoId}${children.numero}`"
                    :ref="`resposta${children.grupoId}${children.numero}`"
                    :accept="children.tipoExtensaoPermitida"
                    placeholder="Selecione o arquivo"
                    v-model="
                      payload[children.grupoId][children.numero].resposta
                    "
                    v-if="!isEnviada()"
                    :disabled="
                      payload[children.grupoId][children.numero].status ==
                        'loading' ||
                      isEnviada() ||
                      (payload[children.grupoId][children.numero].files &&
                        payload[children.grupoId][children.numero].files
                          .length == children.quantidadePermitida)
                    "
                    :hint="`Quantidade de arquivos:
                    ${children.quantidadePermitida} `"
                    persistent-hint
                    @change="
                      () => {
                        save(
                          children,
                          grupo,
                          `resposta${children.grupoId}${children.numero}`,
                          i,
                          true
                        );
                      }
                    "
                  >
                  </v-file-input>
                  <div
                    v-if="
                      isEnviada() &&
                      payload[children.grupoId][children.numero].files.length ==
                        0
                    "
                    style="font-size: 14px; margin: 5px 26px; opacity: 0.5"
                  >
                    Nenhum arquivo enviado
                  </div>
                  <div
                    style="
                      display: flex;
                      row-gap: 20px;
                      flex-direction: column;
                      margin: 0 10px;
                      z-index: 1;
                      position: relative;
                      margin-top: 1rem;
                    "
                    v-if="
                      payload[children.grupoId][children.numero].files &&
                      payload[children.grupoId][children.numero].files.length >
                        0
                    "
                  >
                    <div
                      style="color: #2d6189"
                      v-for="(file, index) in payload[children.grupoId][
                        children.numero
                      ].files"
                      :key="index"
                    >
                      <span
                        style="cursor: pointer"
                        @click="
                          downloadEvidencia(
                            file.evidenciaId,
                            children,
                            payload[children.grupoId][children.numero],
                            file.filename
                          )
                        "
                        >{{ file.filename }}</span
                      >
                      <v-btn
                        outlined
                        color="error"
                        class="ml-3"
                        v-if="!isEnviada()"
                        @click="
                          deleteFile(
                            file.evidenciaId,
                            payload[children.grupoId][children.numero]
                          )
                        "
                      >
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div class="status">
                  <template>
                    <div
                      class="salvar"
                      v-if="
                        payload[children.grupoId][children.numero].status ==
                        'success'
                      "
                    >
                      <v-icon color="#0c6b10"
                        >mdi-checkbox-marked-circle</v-icon
                      >
                      Salvo
                    </div>

                    <div
                      class="salvarErro"
                      v-if="
                        payload[children.grupoId][children.numero].status ==
                        'error'
                      "
                    >
                      <v-icon color="#FF5252">mdi-block-helper</v-icon>
                      Não Salvo
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div
              v-if="
                payload[children.grupoId][children.numero].status == 'loading'
              "
              style="position: absolute; left: 50%; top: 29%; z-index: 1"
            >
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <v-btn color="laranja" @click="back()" style="color: #fff">
          {{ !isEnviada() ? "Salvar e sair" : "voltar" }}
        </v-btn>
        <template
          v-if="
            isFullAdmin ||
            (config.podeFinalizarClienteOculto &&
              groupsConfig.podeFinalizarClienteOculto)
          "
        >
          <v-btn
            color="azulclarosc"
            @click="enviarAnalise"
            v-if="!isEnviada()"
            style="color: #fff"
          >
            Finalizar
          </v-btn>
        </template>
      </div>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import tipoDiagnosticoEnum from "../tipoDiagnostico";

import { cityAPI } from "@/modules/city";
import moment from "moment";

import { seloClienteOcultoPerguntasAPI } from "../API/seloClienteOcultoPerguntasAPI";
import { seloClienteOcultoRespostaAPI } from "../API/seloClienteOcultoRespostaAPI";
import { seloClienteOcultoEvidenciasAPI } from "../API/seloClienteOcultoEvidenciasAPI";
import { groupColours, questionColours } from "../colours";
import { seloDiagnosticoRespostaAPI } from "@/modules/diagnosticoSelo/API/seloDiagnosticoRespostaAPI";
import { seloDiagnosticoEvidenciasAPI } from "@/modules/diagnosticoSelo/API/seloDiagnosticoEvidenciasAPI";

import AppModalShowEvidence from "@/modules/diagnostic/components/ModalShowEvidence";

import * as tus from "tus-js-client";
import Swal from "sweetalert2";

export default {
  components: {
    AppModalShowEvidence,
  },
  data() {
    return {
      payload: {},
      openedGroup: null,
      headers: [],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      municipio: {},
      tiposCampoMapeados: {},
      closeGrupos: {},
      allRespostas: [],
      groupColours: groupColours,
      questionColours: questionColours,
      respostaDiagnosticoSelo: null,
      evidenciasDiagnosticoSelo: [],
      breadCrumbs: [
        {
          text: "Selecionar a Sala",
          disabled: false,
          to: "/",
          exact: true,
        },
        {
          text: "Sala",
          disabled: false,
          to: `/cidade/${this.$route.params.id}`,
          exact: true,
        },
        {
          text: "Status Cliente Oculto",
          disabled: false,
          to: `/cidade/${this.$route.params.id}/cliente-oculto/info`,
          exact: true,
        },
        {
          text: "Cliente Oculto",
          disabled: false,
          to: `/cidade/${this.$route.params.id}/cliente-oculto`,
          exact: true,
        },
      ],
      municipioId: this.$route.params.id,
      rulesHoras: (v) => {
        if (!this.horaRegex.test(v)) {
          return "Hora inválida";
        }
        return true;
      },
      rulesMaxIntervalo: (v) => {
        // eslint-disable-next-line eqeqeq
        if (v && v.length != 11) {
          return "Intervalo inválido";
        }
        return true;
      },
      rulesMaxCep: (v) => {
        // eslint-disable-next-line eqeqeq
        if (v && v.length != 9) {
          return "CEP inválido";
        }
        return true;
      },
      rulesTelCep: (v) => {
        if (v && v.length < 13) {
          return "Telefone inválido";
        }
        return true;
      },
      rulesObg: (v) => {
        if (v === false) {
          return true;
        }
        // eslint-disable-next-line eqeqeq
        if (v == "" || !v) {
          return "Campo Obrigatório";
        }
        return true;
      },

      rulesFile: (files) => {
        if (files) {
          var somaTotal = 0;
          if (Array.isArray(files)) {
            somaTotal = files.reduce((a, b) => {
              return a + b.size;
            }, 0);
          } else {
            somaTotal = files.size;
          }

          return somaTotal > 7000000
            ? "Total de arquivos não pode ser maior que 5MB!"
            : true;
        }

        return !files;
      },
      rulesVideo: (files) => {
        if (files) {
          var somaTotal = 0;
          if (Array.isArray(files)) {
            somaTotal = files.reduce((a, b) => {
              return a + b.size;
            }, 0);
          } else {
            somaTotal = files.size;
          }

          return somaTotal > 30000000
            ? "Total de arquivos não pode ser maior que 30MB!"
            : true;
        }

        return !files;
      },
      horaRegex: /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/,
      emailREgex:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      rules: [
        (v) => {
          if (v === false) {
            return true;
          }
          // eslint-disable-next-line eqeqeq
          if (v == "" || !v) {
            return "Campo Obrigatório";
          }
          return true;
        },
      ],
      emailRules: [
        (v) =>
          !v
            ? "Campo Obrigatório"
            : !this.emailREgex.test(v)
            ? "E-mail inválido"
            : true,
      ],
      user: JSON.parse(localStorage.getItem("user")),
      perguntas: [],
      tipoDiagnostico: tipoDiagnosticoEnum,
      allPerguntas: [],
      //  idPerguntaCoringa: 143,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    habilitar(grupoId) {
      // if (grupoId == 2 && this.payload[1][1].resposta) {
      //   return true;
      // }

      // if (grupoId == 3 && this.payload[1][2].resposta) {
      //   return true;
      // }
      if (this.isParceiro) {
        if (this.verificaParceiro[`pergunta${grupoId}`]) {
          return this.verificaParceiro[`pergunta${grupoId}`].resposta ==
            "true" ||
            this.verificaParceiro[`pergunta${grupoId}`].resposta == true
            ? true
            : false;
        }

        return true;
      }

      if (this.verifica[`pergunta${grupoId}`]) {
        return this.verifica[`pergunta${grupoId}`].resposta == "true" ||
          this.verifica[`pergunta${grupoId}`].resposta == true
          ? true
          : false;
      }
      return true;
    },
    aparecerAbaixoPerguntaCoringa(perguntaId) {
      const pergunta = this.allPerguntas.filter(
        (p) => p.perguntaId == this.idPerguntaCoringa
      )[0];
      const resposta = this.payload[pergunta.grupoId][pergunta.perguntaId];

      if (resposta && resposta.resposta) {
        return true;
      }

      if (perguntaId > this.idPerguntaCoringa) {
        return false;
      } else {
        return true;
      }
    },
    getRespostaDiagnostico() {
      this.setLoading(true);

      seloDiagnosticoRespostaAPI.list(this.municipioId).then((item) => {
        this.respostaDiagnosticoSelo = item.data;
        this.getEvidenciasDiagnostico();
      });
    },
    getEvidenciasDiagnostico() {
      seloDiagnosticoEvidenciasAPI
        .getEvidenciaPerguntas53_54_55_56(this.municipioId)
        .then((item) => {
          this.evidenciasDiagnosticoSelo = item.data;
          this.setLoading(false);
        });
    },
    statusPreGrupo(grupo, index) {
      const valoresGrupo = Object.values(this.payload[grupo.grupoId]);
      if (
        valoresGrupo.some((item) => {
          // eslint-disable-next-line eqeqeq
          return item.status == "error";
        })
      ) {
        this.perguntas[index].status = "error";
        this.$forceUpdate();
        return;
      }
      // eslint-disable-next-line eqeqeq
      if (valoresGrupo.some((item) => item.status == "success")) {
        this.perguntas[index].status = "inProgress";
        this.$forceUpdate();
        return;
      }

      this.perguntas[index].status = "";
      this.$forceUpdate();
    },
    mostrarDependente(children) {
      if (children.respostaDependente == 1) {
        return (
          this.payload[children.grupoId][children.dependente] &&
          this.payload[children.grupoId][children.dependente].resposta
        );
      }

      if (children.respostaDependente == 0)
        return (
          this.payload[children.grupoId][children.dependente] &&
          this.payload[children.grupoId][children.dependente].resposta === false
        );
    },
    statusGrupo(grupo, index) {
      const valoresGrupo = Object.values(this.payload[grupo.grupoId]);

      if (this.grupoCompleto(grupo)) {
        this.perguntas[index].status = "completed";
        this.$forceUpdate();
        return;
      }
      // eslint-disable-next-line eqeqeq
      if (valoresGrupo.some((item) => item.status == "success")) {
        this.perguntas[index].status = "inProgress";
        this.$forceUpdate();
        return;
      }

      this.perguntas[index].status = "";
      this.$forceUpdate();
    },
    onClickOpenGroup(grupo) {
      if (this.openedGroup == grupo) {
        this.openedGroup = null;
      } else {
        this.openedGroup = grupo;
      }
    },
    mapRespostas() {
      seloClienteOcultoRespostaAPI
        .list(this.municipioId)
        .then((item) => {
          let resposta = item.data;
          this.allRespostas = item.data;

          let a =
            resposta.reduce(function (rv, x) {
              rv[x["perguntaGrupoId"]] = { ...rv[x["perguntaGrupoId"]] };
              if (!x.nomeArquivo) {
                rv[x["perguntaGrupoId"]][x["perguntaId"]] = x;
              } else {
                if (rv[x["perguntaGrupoId"]][x["perguntaId"]]) {
                  rv[x["perguntaGrupoId"]][x["perguntaId"]] = [
                    ...rv[x["perguntaGrupoId"]][x["perguntaId"]],
                    x,
                  ];
                } else rv[x["perguntaGrupoId"]][x["perguntaId"]] = [x];
              }

              return rv;
            }, {}) || {};

          this.payload = this.allPerguntas.reduce(function (rv, x) {
            if (
              x.tipoNome.toLowerCase().indexOf("arquivo") > -1 ||
              x.tipoNome.toLowerCase().indexOf("video") > -1 ||
              x.tipoNome.toLowerCase().indexOf("áudio") > -1
            ) {
              if (!rv[x["grupoId"]]) {
                rv[x["grupoId"]] = {};
              }
              if (!a[x["grupoId"]]) {
                a[x["grupoId"]] = {};
              }

              if (!a[x["grupoId"]][x["numero"]]) {
                rv[x["grupoId"]][x["numero"]] = { resposta: null, files: [] };
              } else {
                rv[x["grupoId"]][x["numero"]] = {
                  ...a[x["grupoId"]][x["numero"]][0],
                  resposta: null,
                  status: "success",
                  files:
                    Array.isArray(a[x["grupoId"]][x["numero"]]) &&
                    a[x["grupoId"]][x["numero"]].map((item) => ({
                      filename: item.nomeArquivo,
                      url: item.url,
                      evidenciaId: item.evidenciaId,
                    })),
                };
              }
            } else {
              if (!a[x["grupoId"]] && !rv[x["grupoId"]]) {
                a[x["grupoId"]] = { ...a[x["grupoId"]] };
                rv[x["grupoId"]] = { ...rv[x["grupoId"]] };
                rv[x["grupoId"]][x["numero"]] = { resposta: null };
              } else if (a[x["grupoId"]] && !rv[x["grupoId"]]) {
                if (
                  a[x["grupoId"]][x["numero"]] &&
                  a[x["grupoId"]][x["numero"]].resposta == "true"
                ) {
                  a[x["grupoId"]][x["numero"]].resposta = true;
                }
                // eslint-disable-next-line eqeqeq
                if (
                  a[x["grupoId"]][x["numero"]] &&
                  a[x["grupoId"]][x["numero"]].resposta == "false"
                ) {
                  a[x["grupoId"]][x["numero"]].resposta = false;
                }

                rv[x["grupoId"]] = {};
                rv[x["grupoId"]][x["numero"]] = (a[x["grupoId"]][
                  x["numero"]
                ] && {
                  ...a[x["grupoId"]][x["numero"]],
                  status: "success",
                }) || { resposta: null };
              } else if (!a[x["grupoId"]][x["numero"]]) {
                rv[x["grupoId"]][x["numero"]] = { resposta: null };
              } else {
                rv[x["grupoId"]] = { ...rv[x["grupoId"]] };
                // eslint-disable-next-line eqeqeq
                if (a[x["grupoId"]][x["numero"]].resposta == "true") {
                  a[x["grupoId"]][x["numero"]].resposta = true;
                }
                // eslint-disable-next-line eqeqeq
                if (a[x["grupoId"]][x["numero"]].resposta == "false") {
                  a[x["grupoId"]][x["numero"]].resposta = false;
                }

                rv[x["grupoId"]][x["numero"]] = {
                  ...a[x["grupoId"]][x["numero"]],
                  status: "success",
                };
              }
            }

            return rv;
          }, {});

          this.perguntas.forEach((val) => {
            if (this.grupoCompleto(val)) {
              val.status = "completed";
            }

            this.desabilitar(val);
          });

          this.getRespostaDiagnostico();
          this.$forceUpdate();
        })
        .catch((err) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter respostas");

          console.log("mapRespostas err: ", err);
          this.setLoading(false);
        });
    },
    desabilitar(val) {
      const perguntasId = [61, 62, 63, 64, 65, 66];

      const p = val.children.find(
        (item) =>
          perguntasId.includes(item.numero) &&
          this.payload[item.grupoId][item.numero].resposta == true
      );

      if (p) {
        Object.keys(this.payload[p.grupoId]).forEach((val) => {
          if (
            val != p.numero &&
            p.tipoResposta == this.tipoDiagnostico.boolean
          ) {
            if (this.payload[p.grupoId][p.numero].resposta == true) {
              this.payload[p.grupoId][val].desabilitado = true;
            } else {
              this.payload[p.grupoId][val].desabilitado = false;
            }
          }
        });
      }
    },
    getOptions(file) {
      return {
        endpoint:
          "https://api.cloudflare.com/client/v4/accounts/e2f8a6cba3853a64e90ed0683c02e9c8/stream",
        headers: {
          Authorization: "Bearer gUgZlz0PyIrgJA1SyZd6s-cVsLQv-3fMqu-6IQNU",
        },
        chunkSize: 50 * 1024 * 1024, // Required a minimum chunk size of 5MB, here we use 50MB.
        retryDelays: [0, 3000, 5000, 10000, 20000], // Indicates to tus-js-client the delays after which it will retry if the upload fails
        metadata: {
          filename: file.name,
          filetype: file.type,
        },
      };
    },
    save(children, grupo, nomeForm, index, isFile) {
      // eslint-disable-next-line eqeqeq
      if (this.payload[children.grupoId][children.numero].status == "loading") {
        return;
      }

      this.$forceUpdate();
      const refName = this.$refs[nomeForm][0];
      const valid = refName.validate();
      if (!valid) {
        this.payload[children.grupoId][children.numero].status = "error";
        this.statusPreGrupo(grupo, index);
        this.$forceUpdate();
        return;
      }

      if (
        children.numero == 61 ||
        children.numero == 62 ||
        children.numero == 63 ||
        children.numero == 64 ||
        children.numero == 65 ||
        children.numero == 66
      ) {
        Object.keys(this.payload[children.grupoId]).forEach((val) => {
          const p = this.perguntas
            .find((item) => item.grupoId == children.grupoId)
            .children.find((c) => c.numero == val);
          if (
            val != children.numero &&
            p.tipoResposta == this.tipoDiagnostico.boolean
          ) {
            if (
              this.payload[children.grupoId][children.numero].resposta == true
            ) {
              this.payload[children.grupoId][val].desabilitado = true;

              if (
                this.payload[children.grupoId][val].resposta != false ||
                this.payload[children.grupoId][val].resposta == null
              ) {
                this.payload[children.grupoId][val].resposta = false;

                this.save(p, grupo, `resposta${children.grupoId}${val}`, index);
              }
            } else {
              this.payload[children.grupoId][val].desabilitado = false;
            }
          }
        });
      }
      const save = {
        municipioId: this.municipioId,
        usuarioId: this.user.usuarioId,
        perguntaId: children.numero,
        dataHora: moment().format("YYYY-MM-DD HH:mm:ss"),
        resposta: isFile
          ? ""
          : this.payload[children.grupoId][children.numero].resposta,
        respostaId: this.payload[children.grupoId][children.numero].respostaId,
        respondida: true,
        enviada: false,
        perguntaGrupoId: children.grupoId,
      };

      if (isFile) {
        this.setLoading(true);
        if (!this.payload[children.grupoId][children.numero].resposta) {
          this.setLoading(false);

          return;
        }
      }

      seloClienteOcultoRespostaAPI
        .atualizar(save)
        .then(async ({ data }) => {
          if (isFile) {
            var file = this.payload[children.grupoId][children.numero].resposta;
            if (
              Array.isArray(
                this.payload[children.grupoId][children.numero].resposta
              )
            ) {
              file =
                this.payload[children.grupoId][children.numero].resposta[0];
            }

            if (file.type.indexOf("video") > -1) {
              const minhaPromise = new Promise((resolve, reject) => {
                var upload = new tus.Upload(file, {
                  ...this.getOptions(file, children),
                  onError: function (error) {
                    console.log("error: ", error);
                    throw error;
                  },
                  onSuccess: function () {
                    resolve(upload);
                  },
                });

                upload.start();
              });
              let formData = new FormData();

              const val = await minhaPromise;

              formData.append("usuarioId", save.usuarioId);
              formData.append("perguntaId", save.perguntaId);

              formData.append("municipioId", save.municipioId);
              formData.append("respostaId", data.respostaId);
              formData.append("url", val.url);
              formData.append("nomeArquivo", val.file.name);

              seloClienteOcultoEvidenciasAPI
                .add(formData)
                .then(() => {
                  this.filteredItems();
                })
                .catch((err) => {
                  this.setLoading(false);
                  console.log("err: ", err);
                  this.$notification.error(
                    "Erro ao salvar o arquivo da pergunta: ",
                    save.perguntaId
                  );
                  this.payload[children.grupoId][children.numero].status =
                    "error";
                  this.statusGrupo(grupo, index);
                  this.$forceUpdate();
                });
            } else {
              let formData = new FormData();

              if (
                Array.isArray(
                  this.payload[children.grupoId][children.numero].resposta
                )
              ) {
                for (
                  let i = 0;
                  i <
                  this.payload[children.grupoId][children.numero].resposta
                    .length;
                  i++
                ) {
                  formData.append(
                    "arquivo",
                    this.payload[children.grupoId][children.numero].resposta[i]
                  );
                }
              } else {
                formData.append(
                  "arquivo",
                  this.payload[children.grupoId][children.numero].resposta
                );
              }
              formData.append("usuarioId", save.usuarioId);
              formData.append("perguntaId", save.perguntaId);

              formData.append("municipioId", save.municipioId);
              formData.append("respostaId", data.respostaId);

              seloClienteOcultoEvidenciasAPI
                .add(formData)
                .then(() => {
                  this.filteredItems();
                })
                .catch((err) => {
                  this.setLoading(false);
                  console.log("err: ", err);
                  this.$notification.error(
                    "Erro ao salvar o arquivo da pergunta: ",
                    save.perguntaId
                  );
                  this.payload[children.grupoId][children.numero].status =
                    "error";
                  this.statusGrupo(grupo, index);
                  this.$forceUpdate();
                });
            }
          } else {
            this.payload[children.grupoId][children.numero].status = "success";
            this.statusGrupo(grupo, index);
            this.$forceUpdate();
          }
        })
        .catch((err) => {
          this.setLoading(false);
          this.$notification.error("Erro ao salvar a pergunta");

          console.log("err: ", err);
          this.payload[children.grupoId][children.numero].status = "error";
          this.statusGrupo(grupo, index);
          this.$forceUpdate();
        });
    },
    downloadEvidenciaDiagnostico(evidenciaId, url) {
      if (url) {
        let link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.click();
      } else {
        seloDiagnosticoEvidenciasAPI
          .download(evidenciaId)
          .then((resp) => {
            let blob = new Blob([resp.data], {
              type: resp.headers["content-type"],
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.target = "_blank";
            link.click();

            this.setLoading(false);
          })
          .catch((resp) => {
            console.log("resp: ", resp);
            this.setLoading(false);
            this.$notification.error("Erro ao obter anexo");
          });
      }
    },
    downloadEvidencia(evidenciaId, pergunta, resposta, filename) {
      // eslint-disable-next-line eqeqeq
      if (
        pergunta.tipoResposta == this.tipoDiagnostico.video ||
        pergunta.tipoResposta == this.tipoDiagnostico.arquivo
      ) {
        let link = document.createElement("a");
        link.href = resposta.files.find(
          (item) => item.evidenciaId == evidenciaId
        ).url;
        link.target = "_blank";

        link.click();
      } else {
        seloClienteOcultoEvidenciasAPI
          .download(evidenciaId)
          .then((resp) => {
            let blob = new Blob([resp.data], {
              type: "application/force-download",
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;

            link.target = "_blank";
            link.click();

            this.setLoading(false);
          })
          .catch((resp) => {
            console.log("resp: ", resp);
            this.setLoading(false);
            this.$notification.error("Erro ao obter anexo");
          });
      }
    },

    grupoCompleto(grupo) {
      const valoresGrupo = Object.values(this.payload[grupo.grupoId]);
      // eslint-disable-next-line eqeqeq
      return valoresGrupo.every((item) => {
        let pergunta = grupo.children.filter(
          (val) => val.perguntaId == item.perguntaId
        )[0];
        return item.status == "success";
      });
    },
    filteredItems() {
      this.setLoading(true);

      seloClienteOcultoPerguntasAPI
        .getPerguntas()
        .then((val) => {
          this.allPerguntas = val.data;
          let groupBy = val.data;

          let key = "grupoId";
          let aux = groupBy.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
          }, {});

          this.perguntas = Object.keys(aux).map((key) => {
            return {
              grupoId: key,
              name: aux[key] && aux[key][0].grupoNome,
              children: aux[key],
              close: true,
            };
          });

          this.municipioInfo();
        })
        .catch((err) => {
          this.$notification.error("Erro ao obter perguntas");

          console.log("filteredItems err: ", err);
          this.setLoading(false);
        });
    },
    deleteFile(evidenciaId, children) {
      this.payload[children.perguntaGrupoId][children.perguntaId].status =
        "loading";

      seloClienteOcultoEvidenciasAPI
        .delete(evidenciaId)
        .then(() => {
          if (children.files && children.files.length > 0) {
            children.files.forEach((file, index) => {
              // eslint-disable-next-line eqeqeq
              if (file.evidenciaId == evidenciaId) {
                children.files.splice(index, 1);
              }
            });
          }

          this.payload[children.perguntaGrupoId][children.perguntaId].files =
            children.files;
          // eslint-disable-next-line eqeqeq
          if (!children.files || children.files.length == 0) {
            seloClienteOcultoRespostaAPI
              .delete(
                this.payload[children.perguntaGrupoId][children.perguntaId]
                  .respostaId
              )
              .then(() => {
                this.filteredItems();
              })
              .catch((err) => {
                this.setLoading(false);
                console.log(
                  "diagnosticoSelo/List deleteFile delete resposta ",
                  err
                );
                this.$notification.error("Erro ao excluir o arquivo");
              });
          } else {
            this.filteredItems();
          }
        })
        .catch((err) => {
          this.setLoading(false);
          console.log("diagnosticoSelo/List deleteFile delete file", err);
          this.$notification.error("Erro ao excluir o arquivo");
        });
    },
    municipioInfo() {
      this.setLoading(true);
      cityAPI
        .get(this.municipioId)
        .then((municipio) => {
          this.municipio = municipio.data;
          this.mapRespostas();
        })
        .catch((err) => {
          this.setLoading(false);
          console.log("daignosticoSelo/List municipioInfo ", err);
          this.$notification.error("Erro ao buscar municipio");
        });
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    isEnviada() {
      // eslint-disable-next-line eqeqeq
      if (this.allRespostas.length == 0) return false;
      if (this.allRespostas.every((item) => item.enviada)) return true;

      return false;
    },
    isRulesNeeded(pergunta, resposta, desabilitado) {
      if (pergunta.obrigatorio && !pergunta.dependente && desabilitado)
        return true;
      if (pergunta.dependente && pergunta.obrigatorio && !desabilitado) {
        let dependente = this.payload[pergunta.grupoId][pergunta.dependente];
        if (dependente.resposta || dependente.resposta === false) return true;
        else return false;
      }

      return false;
    },
    async enviarAnalise() {
      var isValid = await this.check();

      if (!isValid) {
        const errorElement = document.querySelector(".error--text");
        const grupoId = errorElement.parentNode.className.substring(
          errorElement.parentNode.className.indexOf("grupoId_") + 8,
          errorElement.parentNode.className.length
        );
        this.onClickOpenGroup(grupoId);
        errorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
        return;
      }
      Swal.fire({
        title: "Finalizar",
        text: `Ao finalizar os dados não poderão ser alterados. Deseja continuar?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.enviarAnaliseFim();
        }
      });
    },
    enviarAnaliseFim() {
      this.setLoading(true);
      seloClienteOcultoRespostaAPI
        .enviarAnalise(this.municipioId)
        .then(() => {
          this.setLoading(false);
          this.filteredItems();
          this.$notification.success(
            "O processo de Cliente Oculto foi finalizado com Sucesso. Obrigado!"
          );
        })
        .catch((err) => {
          this.setLoading(false);

          this.$notification.error("Erro finalizar");
          console.log("diagnosticoselo/list enviarAnalise ", err);
        });
    },
    back() {
      if (!this.isEnviada()) {
        Swal.fire({
          title: "As respostas foram salvas",
          text: `Lembramos que o processo do Cliente Oculto não foi finalizado!`,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed) {
            this.$router.push("/cidade/" + this.municipioId);
          }
        });
      } else {
        this.$router.push("/cidade/" + this.municipioId);
      }
    },
  },

  beforeMount() {
    if (this.isParceiro) {
      // this.idPerguntaCoringa = 115;

      this.breadCrumbs = [
        {
          text: "Selecionar o Parceiro",
          disabled: false,
          to: "/",
          exact: true,
        },
        {
          text: "Parceiro",
          disabled: false,
          to: `/cidade/${this.$route.params.id}/geral`,
          exact: true,
        },
        {
          text: "Status Cliente Oculto",
          disabled: false,
          to: `/cidade/${this.$route.params.id}/cliente-oculto/info`,
          exact: true,
        },
        {
          text: "Cliente Oculto",
          disabled: false,
          to: `/cidade/${this.$route.params.id}/cliente-oculto`,
          exact: true,
        },
      ];
    }
    this.filteredItems();
  },

  computed: {
    ...mapGetters(["isSala", "isFullAdmin", "isParceiro"]),
    googleMeuNegocio() {
      return (
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 10 || item.perguntaId == 11
        )
      );
    },
    telefonePergunta1() {
      return (
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 18 || item.perguntaId == 20
        )
      );
    },
    telefonePergunta2() {
      return (
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 22)
      );
    },
    instagram55() {
      if (this.isParceiro) {
        const resposta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find(
            (item) => item.perguntaId == 20 && item && item.resposta
          );

        const insta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 21);

        return resposta && resposta.resposta == "true" ? insta : null;
      }

      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 23 && item.resposta
        );

      const insta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 24);

      return resposta && resposta.resposta == "true" ? insta : null;
    },
    facebook55() {
      if (this.isParceiro) {
        const resposta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find(
            (item) => item.perguntaId == 22 && item.resposta
          );

        const insta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 23);

        return resposta && resposta.resposta == "true" ? insta : null;
      }

      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 25 && item.resposta
        );

      const insta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 26);

      return resposta && resposta.resposta == "true" ? insta : null;
    },
    sieBlog55() {
      if (this.isParceiro) {
        const resposta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find(
            (item) => item.perguntaId == 24 && item.resposta
          );

        const insta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 25);

        return resposta && resposta.resposta == "true" ? insta : null;
      }

      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 27 && item.resposta
        );

      const insta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 28);

      return resposta && resposta.resposta == "true" ? insta : null;
    },

    verifica() {
      return {
        pergunta2:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 17),
        pergunta3:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 21),
        pergunta4:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 15),
      };
    },
    verificaParceiro() {
      return {
        pergunta4:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 12),
        pergunta2:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 14),
        pergunta3:
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 18),
      };
    },
    realizaEmail58() {
      if (this.isParceiro) {
        const resposta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 12);

        return resposta && resposta.resposta == "true" ? "Sim" : "Não";
      }
      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 15);

      return resposta && resposta.resposta == "true" ? "Sim" : "Não";
    },
    email58() {
      if (this.isParceiro) {
        const resposta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find(
            (item) => item.perguntaId == 12 && item.resposta
          );

        const email =
          (this.respostaDiagnosticoSelo &&
            this.respostaDiagnosticoSelo.find(
              (item) => item.perguntaId == 13
            )) ||
          {};

        return resposta && resposta.resposta == "true" ? email.resposta : null;
      }

      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 15 && item.resposta
        );

      const email =
        (this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 16)) ||
        {};

      return resposta && resposta.resposta == "true" ? email.resposta : null;
    },
    whatsapp58() {
      if (this.isParceiro) {
        const resposta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find(
            (item) => item.perguntaId == 18 && item.resposta
          );

        const email =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 19);

        return resposta && resposta.resposta ? email : null;
      }

      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find(
          (item) => item.perguntaId == 21 && item.resposta
        );

      const email =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 22);

      return resposta && resposta.resposta ? email : null;
    },
    realizaWhatsapp58() {
      if (this.isParceiro) {
        const resposta =
          this.respostaDiagnosticoSelo &&
          this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 18);

        return resposta && resposta.resposta == "true" ? "Sim" : "Não";
      }

      const resposta =
        this.respostaDiagnosticoSelo &&
        this.respostaDiagnosticoSelo.find((item) => item.perguntaId == 21);

      return resposta && resposta.resposta == "true" ? "Sim" : "Não";
    },
  },
};
</script>
<style lang="scss" scoped>
.subtitulo {
  font-size: 14px;
}
.buttons {
  display: flex;
  justify-content: flex-end;
  column-gap: 1rem;
  margin-top: 1rem;
}
.grupo {
  margin-bottom: 1rem;
}

.imagensDiagnostico {
  display: flex;
  flex-wrap: wrap;
  column-gap: 5px;
  margin-top: 10px;
  .arquivo {
    background: #2d6189;
    color: #fff;
    padding: 10px;
    border-radius: 10px;
    font-size: inherit;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
      rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  }

  .arquivo:hover {
    background: #03528f;
  }
}

.enviada {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  text-align: center;
  margin: 2rem;
  font-size: 20px;
  /* font-weight: bold; */
  background: #606060;
  border-radius: 19px;
  padding: 10px;
  color: #fff;
  margin: 2rem auto;
  display: flex;
  align-items: center;
  column-gap: 10px;
}

.salvar {
  color: #0c6b10;
  border-radius: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-left: auto;
  column-gap: 5px;
}

.status {
  border-radius: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-left: auto;
  column-gap: 5px;
}

.salvarErro {
  color: #ff5252;
}

.bloco {
  position: sticky;
  top: 140px;
  background: #2d6189;
  color: #fff;
  padding: 10px;
  z-index: 2;
  display: flex;
  column-gap: 10px;
  cursor: pointer;
}
.completed {
  background: #0c6b10;
}

.error {
  background: #ff5252;
}

.inProgress {
  background: #f57d30;
  color: #fff;
  text-shadow: 3px 3px 13px rgba(0, 0, 0, 0.38);
}

.children {
  border: 1px solid #c1bebe8c;
  position: relative;
  .filho {
    display: flex;
  }
}
.children {
  padding: 10px;

  .numeration {
    font-weight: bold;
    font-size: 14px;
  }
}
</style>
